import { Box } from "@radix-ui/themes";
import { NavContent } from "./nav-content";

export function Sidebar() {
  return (
    <Box
      style={{
        width: "240px",
        borderRight: "1px solid var(--gray-4)",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--gray-1)",
        flexShrink: 0,
      }}
    >
      <NavContent />
    </Box>
  );
}
